import { gql, useMutation } from "@apollo/client";
import Cookies from "js-cookie";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "src/contexts/UserContext";
import { useSnackbar } from "src/utils/hook/base/baseserviceindex";
import useErrorHandling from "src/utils/hook/base/useErrorHandling";

//Schema definition
const login = gql`
  mutation tokenAuthHttpOnly($username: String!, $password: String!) {
    tokenAuthHttpOnly(username: $username, password: $password) {
      statusCode
      message
      access
      accessExpireTime
      refresh
      refreshExpiresIn
      wso2Token
      wso2Expire
      user_ {
        id
        realLegal
      }
    }
  }
`;

const useSecureLogin = () => {
  const { errorHandling } = useErrorHandling();
  const { wSO2Token, setWSO2Token } = useContext(UserContext);

  const fetchWSO2Token = async () => {
    const url = process.env.REACT_APP_WSO2_URL;
    const data = new URLSearchParams();
    data.append("grant_type", "password");
    data.append("username", process.env.REACT_APP_WSO2_USER);
    data.append("password", process.env.REACT_APP_WSO2_PASS);
    data.append("scope", process.env.REACT_APP_WSO2_SCOPE);

    const headers = {
      Authorization: process.env.REACT_APP_WSO2_BASIC,
      "Content-Type": "application/x-www-form-urlencoded",
      apikey: process.env.REACT_APP_WSO2_APIKEY,
    };

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: data,
    };

    try {
      const response = await fetch(url, requestOptions);
      const parseResponse = await response.json();
      if (response?.ok)
      {
      setWSO2Token(parseResponse);
      Cookies.set("nmzbxcbashsaoisd", parseResponse?.access_token);
      }
      else
      {
      errorHandling({message:"خطا ارتباط با سامانه"});
      setWSO2Token("");
      }
    } catch (error) {
      errorHandling(error);
      setWSO2Token("");
    }
  };

  const [mutate, { loading }] = useMutation(login, {
    context: {
      credentials: "include",
      headers: {
        version: process.env.REACT_APP_VERSION,
        Authorization: "",
        AuthorizationWSO2: "Bearer " + wSO2Token?.access_token,
      },
    },
  });
  const { snack } = useSnackbar();
  const navigate = useNavigate();

  const userSecureLogin = (data) => {
    mutate({
      variables: { username: data.username, password: data.password },
      onCompleted: (data) => {
        if (data.tokenAuthHttpOnly.statusCode === 1200) {
          snack.success({
            title: data.tokenAuthHttpOnly.message,
          });

          //این قسمت ها باید بعد حذف گردد
          Cookies.set("Access", data.tokenAuthHttpOnly.access);

          Cookies.set(
            "tdlvjnhdj",
            data.tokenAuthHttpOnly.user_.realLegal === "Real"
              ? "oijusahdfijuhaswfiuhwfouweqrufojhwdfiu"
              : "oizxhonc9uwhfijhbiuwefADHBFIUdhcijbcdw"
          );
          Cookies.set("poijwejsmvcsd", data.tokenAuthHttpOnly.accessExpireTime);
          Cookies.set("pqwlmakxmcer", data.tokenAuthHttpOnly.refresh);
          Cookies.set("opwqkmnzxnsdf", data.tokenAuthHttpOnly.refreshExpiresIn);

          Cookies.set("nmzbxcbashsaoisd", data.tokenAuthHttpOnly.wso2Token);
          Cookies.set("amdehfdmwhjwqlk", data.tokenAuthHttpOnly.wso2Expire);
          navigate("/");
        } else {
          snack.error({
            title: data.tokenAuthHttpOnly.message,
          });
        }
      },
      onError: (error) => {
        errorHandling(error);
      },
    });
  };

  return { userSecureLogin, fetchWSO2Token, loading };
};

export default useSecureLogin;
